import { Component } from "react";
import CenterBox from "../../components/CenterBox";

import Warning from "../../assets/icons/warning.svg";

import "../../assets/icons/material-ui-icon.css";

class ConnectionError extends Component {
    render() {
        const { errorMessage } = this.props;
        return (
            <CenterBox logo cancel="Return to menu" {...this.props}>
                <img src={Warning} className="material-ui-icon" style={{ fontSize: "4.5em" }} alt="Warning" />
                <div className="message-box">
                    {errorMessage || "Connection failed. The server may be unavailable."}
                </div>
            </CenterBox>
        );
    }
}

export default ConnectionError;
